// extracted by mini-css-extract-plugin
module.exports = {"cover":"cover___q_Uuk","coverEdit":"coverEdit___kCVhF","FInput":"FInput___2TsJL","btn":"btn___3vE_o"};